import React from 'react'

export type AlertVariant = 'error' | 'success' | 'info' | 'warning'

interface AlertProps {
  variant?: AlertVariant; children: React.ReactNode; onDismiss?: () => void; style?: React.CSSProperties
}

const ALERT_STYLES: Record<AlertVariant, { bg: string; border: string; color: string; icon: string }> = {
  error:   { bg: 'rgba(239,68,68,0.08)',  border: 'rgba(239,68,68,0.25)',  color: 'var(--status-error)',   icon: '⚠️' },
  success: { bg: 'rgba(34,197,94,0.08)',  border: 'rgba(34,197,94,0.25)',  color: 'var(--status-success)', icon: '✓' },
  info:    { bg: 'rgba(124,58,237,0.06)', border: 'rgba(124,58,237,0.2)',  color: 'var(--accent-primary)', icon: 'ℹ️' },
  warning: { bg: 'rgba(234,179,8,0.08)',  border: 'rgba(234,179,8,0.25)',  color: 'var(--warning)',         icon: '⚡' },
}

export const Alert: React.FC<AlertProps> = ({ variant = 'error', children, onDismiss, style }) => {
  const s = ALERT_STYLES[variant]
  return (
    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.5rem', background: s.bg, border: `1px solid ${s.border}`, borderRadius: '8px', padding: '0.75rem 1rem', fontSize: '0.875rem', color: s.color, ...style }}>
      <span style={{ flexShrink: 0 }}>{s.icon}</span>
      <span style={{ flex: 1 }}>{children}</span>
      {onDismiss && (<button onClick={onDismiss} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'inherit', fontSize: '1rem', lineHeight: 1, opacity: 0.7, flexShrink: 0, padding: 0 }}>✕</button>)}
    </div>
  )
}
